import { Signal } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { listSiteBudgetVersionsQuery } from '@shared/services/gql.service';

export const uniqSiteBudgetNameValidator = (
  siteBudget: Signal<listSiteBudgetVersionsQuery[] | undefined>,
  originalName: string
) => {
  return (control: AbstractControl) => {
    const name = control.value;
    const existingNames = siteBudget()?.find(
      ({ name: existingName }) => existingName === name && originalName !== name
    );

    return existingNames ? { duplicate_site_budget: true } : null;
  };
};
